import './DashboardApp.less';
import React from 'react';
import useBreadcrumb from "../../hooks/useBreadcrumb";
import __ from "../../i18n";
import routes from "../../routing/routes";


export default function DashboardApp() {

    useBreadcrumb([
        {name: __('Dashboard'), url: routes.dashboard.getUrl()}
    ]);

    return <div className="dashboard-app">
        <h2>{__('Welcome to the dashboard')}</h2>
    </div>;
}
